import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import IconSvg from '../IconSvg';

const PillCheckbox = ({ checked, image, onChange, text, value }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const imageEl = useRef();
  const showImage = imageEl && (imageLoaded || imageEl.complete);

  const onLoad = () => {
    setImageLoaded(true);
  };

  const onError = (e) => {
    e.target.src =
      'https://resources.redbull.tv/linear-borb/rbtv_background_landscape/im:i:h_96,w_96,c_fill';
  };

  return (
    <label className={`checkbox checkbox--pill ${showImage ? 'show' : 'hide'}`}>
      <input
        checked={checked}
        type="checkbox"
        value={value}
        onChange={onChange}
      />
      <div className="checkbox__indicator">
        <img
          ref={imageEl}
          src={image}
          alt={text}
          onLoad={onLoad}
          onError={onError}
        />
        <div className="checkbox__icon">
          <IconSvg type="checkmark" />
        </div>
        <span className="checkbox__text">{text}</span>
      </div>
    </label>
  );
};

PillCheckbox.propTypes = {
  image: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

PillCheckbox.defaultProps = {
  image:
    'https://resources.redbull.tv/linear-borb/rbtv_background_landscape/im:i:h_96,w_96,c_fill',
};

export default PillCheckbox;
